import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import { colorToken } from "./armor-system-QCYY7333.js";

// src/properties/color.ts
import { css } from "styled-components";
var colorProps = function colorProps(_ref) {
  var textColor = _ref.color,
    hoverColor = _ref.hoverColor,
    backgroundColor = _ref.backgroundColor;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n"])), textColor !== void 0 && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        color: ", ";\n    "])), colorToken(textColor)), backgroundColor !== void 0 && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        background-color: ", ";\n    "])), colorToken(backgroundColor)), hoverColor !== void 0 && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        &:hover {\n            color: ", ";\n        }\n    "])), colorToken(hoverColor)));
};
export { colorProps };